'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIntlText = getIntlText;
exports.getObj = getObj;
var isClient = exports.isClient = typeof window !== 'undefined';
var isDev = exports.isDev = Boolean(module && module.hot && process.env.NODE_ENV !== 'production');

var EMPTY_INTL = { locale: '[brokkoli] 获取语言包失败，请检查配置', messages: {} };

/**
 * 获取语言包，兼容了本地开发环境、预览环境和线上环境
 *
 * @export
 * @return {object} 语言包对象
 */
function getIntlText() {
  if (!window) return EMPTY_INTL;

  // 统一从 window.__BROCCOLI_EXT_CONFIG__.__intl__ 获取
  // 也兼容 window.__CUTTLE_EXT_CONFIG__.__intl__
  var text = getObj(window, '__BROCCOLI_EXT_CONFIG__.__intl__') || getObj(window, '__CUTTLE_EXT_CONFIG__.__intl__');
  // 兼容预览编辑器
  var isPreviewEditor = window && window.broccoliEditor && typeof window.broccoliEditor.getIntl === 'function';
  if (!text && isPreviewEditor) text = window.broccoliEditor.getIntl();
  var intlMsg = text || EMPTY_INTL;
  window.__intl__ = intlMsg;

  return intlMsg;
}

/**
 * getObj 通过 key string 获取对象的属性值
 *
 * @export
 * @param {object} obj            对象
 * @param {string} [keyStr='']    key string
 * @param {string} [defaultValue] 默认值
 * @return {string}               不存在则返回默认值或 undefined
 */
function getObj(obj) {
  var keyStr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var defaultValue = arguments[2];

  var ARRAY_PATH_REGEXP = /\[\s*(\d+)\s*\]/;
  var keyArr = keyStr.split('.');
  for (var i = 0; i < keyArr.length; i++) {
    var key = keyArr[i];
    if (!obj) {
      return defaultValue;
    }
    var matchArrayPath = key.match(ARRAY_PATH_REGEXP);
    if (matchArrayPath && matchArrayPath[1]) {
      obj = obj[key.replace(ARRAY_PATH_REGEXP, '')][matchArrayPath[1]];
    } else {
      obj = obj[key];
    }
  }
  return obj;
}